export default {
      id: "newsCompany-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#newsCompany-usage",
      toString: function () {
        return this.url;
      }
    }